import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-17c3dab0"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
  class: "name"
};
const _hoisted_3 = {
  class: "theme-info"
};
const _hoisted_4 = {
  class: "area"
};
const _hoisted_5 = {
  class: "time"
};
import { ref, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    themeLists: {
      type: Array,
      required: true,
      default: () => []
    },
    // currentThemeItemIndex: {
    //     type: Number,
    //     default: 0
    // },
    labelName: {
      type: String,
      default: 'name'
    },
    statusLabel: {
      type: String,
      default: 'status'
    },
    statusObj: {
      type: Object,
      default: {
        end: {
          name: '已结束',
          textColor: '#afbbc3',
          color: '175, 187, 195, .3'
        },
        running: {
          name: '执行中',
          textColor: '#62dc9e',
          color: '95, 219, 156, .3'
        },
        waiting: {
          name: '待执行',
          textColor: '#f5a75f',
          color: '244, 165, 93, .3'
        }
      }
    }
  },
  emits: ['on-theme-click'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const themeWarpRef = ref(null);
    const themeInnerRef = ref(null);
    const showArrowIcon = ref(false);
    const currentThemeItemIndex = ref(0);

    const handleThemeItemClick = (item, index) => {
      currentThemeItemIndex.value = index;
      emit('on-theme-click', item, index);
    };

    const themeInnerMouseOver = () => {
      if (themeInnerRef.value.scrollWidth > themeWarpRef.value.offsetWidth) {
        // console.log('超出容器宽度');
        showArrowIcon.value = true;
      }
    };

    const themeInnerMouseLeave = () => {
      showArrowIcon.value = false;
    };

    const arrowClick = offset => {
      const scrollLeft = themeInnerRef.value.scrollLeft;
      themeInnerRef.value.scrollLeft = scrollLeft + offset;
    };

    const getRunTime = () => {
      if (props.themeLists[currentThemeItemIndex.value].scheduleStartTime === '0000-00-00 00:00:00' && props.themeLists[currentThemeItemIndex.value].scheduleStartTime === '0000-00-00 00:00:00') {
        return t('不限');
      } else {
        return props.themeLists[currentThemeItemIndex.value].scheduleStartTime + '~' + props.themeLists[currentThemeItemIndex.value].scheduleEndTime;
      }
    };

    watch(() => currentThemeItemIndex.value, val => {
      nextTick(() => {
        let item = themeWarpRef.value.querySelectorAll('.is-active')[0];
        const halfWidth = themeInnerRef.value.offsetWidth / 2;

        if (item.offsetLeft > halfWidth) {
          themeInnerRef.value.scrollLeft = item.offsetLeft - halfWidth + item.offsetWidth / 2;
        } else {
          themeInnerRef.value.scrollLeft = item.scrollLeft;
        }
      });
    });
    return (_ctx, _cache) => {
      const _directive_crosswiseScroll = _resolveDirective("crosswiseScroll");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        onMouseover: themeInnerMouseOver,
        onMouseleave: themeInnerMouseLeave,
        class: "theme-warp",
        ref_key: "themeWarpRef",
        ref: themeWarpRef
      }, [_createElementVNode("i", {
        style: _normalizeStyle('visibility:' + (showArrowIcon.value ? '' : 'hidden')),
        class: "iconfont icon-normal",
        onClick: _cache[0] || (_cache[0] = $event => arrowClick(-240))
      }, null, 4), _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "theme-inner",
        ref_key: "themeInnerRef",
        ref: themeInnerRef
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.themeLists || [], (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          onClick: $event => handleThemeItemClick(item, index),
          class: _normalizeClass([index === currentThemeItemIndex.value ? 'is-active' : '', "theme-item"])
        }, [_createElementVNode("span", {
          style: _normalizeStyle(['color:' + __props.statusObj[item[__props.statusLabel]].textColor, 'background-color:rgba(' + __props.statusObj[item[__props.statusLabel]].color + ')']),
          class: "status"
        }, _toDisplayString(_ctx.$t(__props.statusObj[item[__props.statusLabel]].name)), 5), _createElementVNode("div", _hoisted_2, _toDisplayString(item.name), 1)], 10, _hoisted_1);
      }), 256))])), [[_directive_crosswiseScroll]]), _createElementVNode("i", {
        style: _normalizeStyle('visibility:' + (showArrowIcon.value ? '' : 'hidden')),
        class: "iconfont icon-ic_chevron_right_px",
        onClick: _cache[1] || (_cache[1] = $event => arrowClick(240))
      }, null, 4)], 544), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('运营国家')) + ": " + _toDisplayString(__props.themeLists[currentThemeItemIndex.value].region), 1), _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('执行时间')) + ": " + _toDisplayString(getRunTime()), 1)])], 64);
    };
  }

});